/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map, distinctUntilChanged, debounceTime} from 'rxjs/operators';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {NgbTypeaheadConfig} from '@ng-bootstrap/ng-bootstrap';





@Component({
    selector: 'typeahead-config',
    templateUrl: './typeahead-config.component.html',
    styleUrls: ['./typeahead-config.component.less'],
    providers: [NgbTypeaheadConfig] // add NgbTypeaheadConfig to the component providers
    ,
    standalone: false
})
export class TypeaheadConfig implements OnInit {
  public model: any;

  @Input() searchItems;
  @Input() searchLabel;

  @Output() onSelected = new EventEmitter<string>();
  @Output() onReset = new EventEmitter();

  // // this is for if you want the typeahead auto pre-fill the inputbox
  // constructor(config: NgbTypeaheadConfig) {
  //   // customize default values of typeaheads used by this component tree
  //   config.showHint = true;
  // }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : this.searchItems.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)),);

  // formatter = (x: {name: string}) => x;

  itemSelected($event){
    this.onSelected.emit($event);
  }

  itemsReseted($event){
    this.model = null;
    this.onReset.emit($event);
  }

  ngOnInit() {
  }

}
